import './shared/global_shims';
import './shared/templates.js';
import './preview/templates.js';
import './preview/preview.contentmanager';
import PreviewMode from './preview/preview';

window.PreviewMode = PreviewMode;
